import React from 'react';

import Link from '../lib/Link';

import logo from '../imgs/logo-noa-gray.png';
import logo2x from '../imgs/logo-noa-gray@2x.png';

export default function NotFound() {
  return <div className='App-404'>
    <img
      src={logo}
      srcSet={`${logo2x} 2x`}
      className='App-404-logo'
      alt='Noa'
    />
    <h1 className='App-404-title'>Oops!</h1>
    <h2>
      {'We can’t find the page you are looking for.'}
    </h2>
    <p className='App-404-message'>
      You can return to the <Link href="/">homepage</Link>,
      or contact <a href='mailto://support@noa.one'>support</a> if the
      problem persists
    </p>
  </div>
}



// WEBPACK FOOTER //
// ./src/views/NotFound.js